module.exports = __webpack_public_path__ + "static/media/Manufacturing.c7bc3264.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/Industries/Manufacturing.svg
// module id = 321
// module chunks = 0